import { computed, Injectable, OnDestroy, signal } from '@angular/core';
import { Question } from '@empathy/survey-core';

@Injectable({ providedIn: 'root' })
export class SurveyQuestionSelectionStateService implements OnDestroy {
  getSelectedQuestionIds = computed(() => this.selectedQuestions$());
  getSelectedMode = computed(() => this.selectMode$());

  private readonly selectMode$ = signal<boolean>(false);
  private readonly selectedQuestions$ = signal<Set<string>>(new Set<string>());

  ngOnDestroy(): void {
    this.selectedQuestions$.set(new Set<string>());
  }

  setSelectMode(selectMode: boolean): void {
    this.selectMode$.set(selectMode);
  }

  selectQuestion(checked: boolean, questionId: string): void {
    const selectedQuestions = new Set(this.selectedQuestions$());

    if (checked) {
      selectedQuestions.add(questionId);
    } else {
      selectedQuestions.delete(questionId);
    }

    this.selectedQuestions$.set(selectedQuestions);
  }

  selectAll(questions: Question[], checked: boolean): void {
    if (checked) {
      this.selectedQuestions$.set(new Set(questions.map((q) => q.id)));
    } else {
      this.selectedQuestions$.set(new Set<string>());
    }
  }

  clear(): void {
    this.selectedQuestions$.set(new Set<string>());
  }
}
